module.exports = kolibriGlobal.coreVue.vuex.constants;